import React from "react";

const EditGlobalSettings = React.lazy(() => import("./edit"));

export default [
  { path: "/global_settings/:id/edit", component: EditGlobalSettings, name: "Edit Global Setting" },
];
